import { Currencies } from 'kennek/interfaces/loans';

export const DEFAULT_CURRENCY: Currencies = 'GBP';
